// extracted by mini-css-extract-plugin
export default {"description":"style_description__+j+u-","fade-in":"style_fade-in__wl73i","top":"style_top__8CGiv","image":"style_image__HuDHa"};